'use client';

import { useLocation } from '@reach/router';
import { Slice } from 'gatsby';
import React, { type FC, useContext, useEffect, useState } from 'react';

import { ThemeButton } from '@/components/buttons/theme-button';
import { ParamLink } from '@/components/links/param-link';
import { MediaQueryContext } from '@/context/media-query';
import { cn } from '@/utils/class-name';

export const Header: FC = () => {
    const location = useLocation();

    const resolution = useContext(MediaQueryContext);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        setIsActive(false);
    }, [location, resolution.desktop]);

    return (
        <header className={cn('header d-flex ai-center bg-white-gray', isActive && 'open')}>
            <div className="container d-flex ai-center g-16">
                <Slice alias="header-extra" />

                <ThemeButton />

                <div className="d-flex jc-end" style={{ flex: '1 1' }}>
                    <button
                        className="header-toggler d-lg-none"
                        aria-label={isActive ? 'Zamknij główną nawigację' : 'Otwórz główną nawigację'}
                        onClick={() => setIsActive(!isActive)}
                    >
                        <span></span>
                        {!isActive && <span></span>}
                        <span></span>
                    </button>
                </div>

                <nav className="header-panel bg-white-gray d-none d-lg-flex">
                    <ul className="list unstyled-list g-16 c-secondary container flex-lg-row">
                        <li>
                            <ParamLink to="/pozyczki-krotkoterminowe/" className="d-flex fs-18">
                                Pożyczki krótkoterminowe
                            </ParamLink>
                        </li>

                        <li>
                            <ParamLink to="/pozyczki-dlugoterminowe/" className="d-flex fs-18">
                                Pożyczki długoterminowe
                            </ParamLink>
                        </li>

                        <li>
                            <ParamLink to="/pozyczki-bankowe/" className="d-flex fs-18">
                                Pożyczki bankowe
                            </ParamLink>
                        </li>
                    </ul>
                </nav>
            </div>

            {isActive && <div className="header-close" onClick={() => setIsActive(!isActive)}></div>}
        </header>
    );
};
